import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    additionalNotes: checkText(settings),
});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Form.Label>Mein Wunsch-Standort</Form.Label>
            {

                values.fieldOfLocation.map((field, index) =>
                    <Form.Group className="mb-3" key={index}>
                        <Form.Check
                            name="location"
                            id={field.displayName}
                            label={field.displayName}
                            value={field.displayName}
                            isValid={touched.location && !errors.location}
                            isInvalid={errors.location}
                            onChange={(event) => {
                                field.onChange(event);
                                handleChange(event);
                            }}
                        />

                    </Form.Group>

                )
            }

            <Form.Group className="mb-3" controlId="formAdditionalNotes">
                <Form.Label>Sollten wir noch etwas wissen (z.B. Gehaltsvorstellung, frühester Eintrittstermin etc.)?</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Sollten wir noch etwas wissen?"
                    type="text"
                    name="additionalNotes"
                    value={values.additionalNotes}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.additionalNotes && !errors.additionalNotes}
                    isInvalid={touched.additionalNotes && errors.additionalNotes}
                    maxLength={20000}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.additionalNotes}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};